import moment from 'moment'

export const nowIsAfterEndOfMonthForDate = (date) => {
  date = moment(date)
  const now = moment()

  return now.isAfter(date.endOf('month'))
}
